import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Methode from "@/components/site/Methode";
import Accompagnement from "@/components/site/Accompagnement";
import Results from "@/components/site/Results";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import Cgv from "@/pages/Cgv";
import Test from "@/pages/Test";
import Parents from "@/pages/Parents";
import Ressources from "@/pages/Ressources";
import LogoSpin3D from "@/components/site/LogoSpin3D";

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", { page_path: location.pathname + location.search });
    }
  }, [location]);
  return null;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/cgv" element={<Cgv />} />
      <Route path="/test" element={<Test />} />
      <Route path="/parents" element={<Parents />} />
      <Route path="/ressources" element={<Ressources />} />
      <Route path="/ressources/:slug" element={<Ressources />} />
    </Routes>
  );
}

function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <LogoSpin3D src="/images/logo-emblem-dark.png" opacity={0.3} z={5} blend="screen" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Methode />
        <Accompagnement />
        <Results />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="bg-obsidian text-chalk font-sans">
      <BrowserRouter>
        <PageTracker />
        <AppRouter />
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
